import { Fragment, useContext, useEffect, useState } from 'react';
import { Col, Card, CardHeader, Table, Form, FormGroup, Label, Input, ModalFooter, Row } from 'reactstrap';
import { Btn } from '../../AbstractElements';
import { useDispatch, useSelector } from 'react-redux';
import CommonModal from '../../Components/Modals/modal';
import Pagination from '../../Components/Pagination/Pagination';
import Empty from '../../Components/Empty/Index';
import SweetAlert from 'sweetalert2';
import { useLocation, useNavigate } from 'react-router';
import CustomizerContext from '../../_helper/Customizer';
import { addenotesChapter, deletEnotesChapter, getenotesChapter, isOpenModal, isPdfOpenModal, ModalToggle, PdfstatusToggle, updateenotesChapter, updateEnotesPdfChapter, } from '../../store/enotesChapterSlice';
import Dropzone from 'react-dropzone-uploader';


const EnotesChapterTable = () => {
  const storeVar = useSelector(state => state.enoteChapter)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const toggle = () => dispatch(ModalToggle());
  const pdfToggle = () => dispatch(PdfstatusToggle());
  const [mainId, setmainId] = useState()
  const [submit, setSubmit] = useState(false);
  const [formVar, setFormVar] = useState({
    keyword: '',
    limit: 10,
    offset: 0,
    currentPage: 1,
    modalTitle: null,
    editState: false,
    title: '',
    chapterId: '',
    price: '',
  });

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("id") || "";
    setmainId(id);

    dispatch(getenotesChapter(formVar.limit, formVar.offset, id))
  }, []);

  const pageChange = (page) => {
    const offset = formVar.limit * (page - 1)
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      currentPage: page,
      offset: offset
    }))
    dispatch(getenotesChapter(formVar.limit, offset, mainId))
  };

  const EditToggleModal = (data) => {
    dispatch(isOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: true,
      chapterId: data._id,
      modalTitle: 'Edit Chapter',
      title: data.title,
      price: data.price,
    }))
  }
  const AddToggleModal = () => {
    dispatch(isOpenModal(true))
    setSubmit(false)
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: false,
      modalTitle: 'Add Chapter',
      title: '',
      price: '',
    }))
  }


  const submitMenu = () => {
    if (titleValid() || priceValid()) {
      setSubmit(true)
      return null
    }
    setSubmit(false)
    if (formVar.editState) {
      dispatch(updateenotesChapter(formVar.chapterId, { title: formVar.title, price: formVar.price }))
    } else {
      dispatch(addenotesChapter({ enoteSubjectId: mainId, title: formVar.title, price: formVar.price }))
    }
  }


  const titleValid = () => {
    if (!formVar.title) {
      return "Title is required";
    }
  }
  const priceValid = () => {
    if (!formVar.price.toString().trim()) {
      return "Price is required";
    }
  }

  const DeleteModel = (data) => {
    SweetAlert.fire({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this imaginary file!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    })
      .then((result) => {
        if (result.value) {
          dispatch(deletEnotesChapter(data._id))
        }
      });
  }

  const ImageEditBannerModal = (data) => {
    dispatch(isPdfOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      chapterId: data._id,
      modalTitle: 'Update Pdf',
      bannerFile: null,
      bannerImageURL: null
    }))
  }

  const handleChangeStatus = ({ meta, file }, status) => {

    if (status === 'done') {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFormVar((prevFormVar) => ({
          ...prevFormVar,
          bannerImageURL: e.target.result,
        }))
      };
      reader.readAsDataURL(file);
      setFormVar((prevFormVar) => ({
        ...prevFormVar,
        bannerFile: file,
      }))
    } else if (status === "removed") {
      setFormVar((prevFormVar) => ({
        ...prevFormVar,
        bannerFile: null,
        bannerImageURL: null,
      }))
    }
  };

  const filesValid = () => {
    if (!formVar.bannerFile) {
      return "Files is required";
    }
  }
  const submitImage = () => {

    if (filesValid()) {
      setSubmit(true)
      return null
    }
    setSubmit(false)
    dispatch(updateEnotesPdfChapter(formVar.chapterId, formVar.bannerFile))
  }


  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Row>
              <Col md="6">
              </Col>
              <Col md="4">
              </Col>
              <Col md="2" className='d-flex justify-content-end align-items-center'>
                <div className="text-end border-2 w-100">
                  <Btn attrBtn={{ color: 'info-gradien', className: 'w-100', size: 'sm', onClick: AddToggleModal }}>
                    Add Chapter
                  </Btn>
                </div>
              </Col>
            </Row>

          </CardHeader>
          <div className='table-responsive'>
            <Table hover={true} className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th scope='col'>Sl.No</th>
                  <th scope='col'>Name</th>
                  <th scope='col'>Price</th>
                  <th scope='col'>Pdf Status</th>
                  <th scope='col'>Pdf Pages</th>
                  <th scope='col'>Pdf Size(M.B)</th>
                  <th scope='col'>Action</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.enotesChapterData?.map((item, index) => (
                  <tr key={index}>
                    <th scope='row'>{index + 1}</th>
                    <td >{item.title}</td>
                    <td >{item.price}</td>
                    <td>
                      {
                        item.pdfURL  && <>
                          <span className={`font-success rounded-1 p-1 me-2 d-flex align-items-center`}>
                            <i className="fa fa-check-circle-o fa-lg" aria-hidden="true"></i>
                            &nbsp; <span>Active</span>
                          </span>
                        </>
                      }
                      {
                        item.pdfURL === '' && <>
                          <span className={`font-warning rounded-1 p-1 me-2 d-flex align-items-center`}>
                            <i className="fa fa-clock-o fa-lg" aria-hidden="true"></i>
                            &nbsp; <span>Pending</span>
                          </span>
                        </>
                      }
                    </td>
                    <td >{item.pages}</td>
                    <td >{item.fileSize}</td>
                    <td>
                      <div className='d-flex gap-2 align-items-center'>
                        <div className='cursor-pointer bg-light-primary font-primary action-icon'>
                          <i className="fa fa-edit fa-lg" onClick={(e) => EditToggleModal(item)}></i>
                          <div className="tooltipCustom">Edit</div>
                        </div>
                        <div className='cursor-pointer font-success action-icon'>
                          <i className="fa fa-picture-o fa-lg" onClick={(e) => ImageEditBannerModal(item)} />
                          <div className="tooltipCustom">Update Pdf</div>
                        </div>
                        <div className='cursor-pointer bg-light-info font-danger action-icon'>
                          <i className="fa fa-trash fa-lg" onClick={(e) => DeleteModel(item)}></i>
                          <div className="tooltipCustom">Delete</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {
            storeVar.totalenotesChapter <= 0 && (
              <Empty />
            )
          }
        </Card>
        {
          storeVar.totalenotesChapter > 0 &&
          <Pagination currentPage={formVar.currentPage} totalItem={storeVar.totalenotesChapter}
            itemsPerPage={formVar.limit} showEllipsisAfter={true} visiblePageCount={3} onPageChange={pageChange} />
        }
      </Col>
      <CommonModal isOpen={storeVar.isOpenModal} title={formVar.modalTitle} toggler={toggle} >
        <Form>
          <FormGroup>
            <Label className="col-form-label" for="recipient-name">Title</Label>
            <Input className="form-control" type="text" placeholder='Enter Chapter Title' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, title: e.target.value }))} value={formVar.title} />
            {submit && titleValid() ? <span className='d-block font-danger'>{titleValid()}</span> : ""}
            <Label className="col-form-label" for="recipient-name">Price</Label>
            <Input className="form-control" type="text" placeholder='Enter Price (0 for free)' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, price: e.target.value }))} value={formVar.price} />
            {submit && priceValid() ? <span className='d-block font-danger'>{priceValid()}</span> : ""}
          </FormGroup>
        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: toggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitMenu }}>Save Changes</Btn>
        </ModalFooter>
      </CommonModal>
      <CommonModal isOpen={storeVar.isPdfOpenModal} title={formVar.modalTitle} toggler={pdfToggle} >
        <Form>
          <FormGroup>
            {
              formVar.bannerImageURL && <>
                <div className='d-flex justify-content-center h-10-r'>
                  <img className=' h-100' src={formVar.bannerImageURL} alt="" />
                </div>
              </>
            }
            <Label className="col-form-label" for="recipient-name">Update Pdf</Label>
            <Dropzone
              className='dropzone dz-clickable'
              onChangeStatus={handleChangeStatus}
              maxFiles={1}
              multiple={false}
              // canCancel={false}
              accept="application/pdf/*"
              inputContent='Drop A File'
              styles={{
                dropzone: { width: '100%', height: 150 },
                dropzoneActive: { borderColor: 'green' },
              }}
            />
            {submit && filesValid() ? <span className='d-block font-danger'>{filesValid()}</span> : ""}
          </FormGroup>

        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: pdfToggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitImage }}>Save Changes</Btn>

        </ModalFooter>
      </CommonModal>
    </Fragment>
  );
};

export default EnotesChapterTable;
